import { useState, Fragment, useContext, useEffect } from 'react';
import AuthContext from '../../../context/authContext';
import DataContext from '../../../context/dataContext';

// Import Material 
import { Box, Button, Divider, Fab, IconButton, makeStyles, Paper, TextField, Typography } from '@material-ui/core'
import SwapVertIcon from '@material-ui/icons/SwapVert';
//import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { NameInput } from '../../addNewView/NameInput';
import { SelectLinkType } from '../../basicComponents/SelectLinkType';
//import { AutocompleteTerms } from '../../basicComponents/AutocompleteTerms';
import { DeleteLink, UpdateLink } from '../../../graphqlCommunication/LinksInterface';

import Draggable from 'react-draggable';
import { TooltipStyle } from '../../basicComponents/HtmlTooltip';
import { DescriptionInput } from '../../addNewView/DescriptionInput';
import BlurOnIcon from '@material-ui/icons/BlurOn';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { GetRelatinDefinitionByChatGpt, GetRelatinTypeByChatGpt } from '../../addNewView/GetDefinitionByChatGpt';
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

//Import Components
/* import { UpdateTerm } from '../../graphqlCommunication/TermsInterface';
import { SelectTermType } from '../basicComponents/SelectTermType'; */


const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: 100,
        maxWidth: 340,
    },
    margin: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    button: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    iconButton: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
    },
    text: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        minWidth: 100,
        width: 396,
    },
    divider: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        marginBottom: theme.spacing(2),
    },
    flexContainer: {
        display: 'flex',
        justifyContent: 'space-between', // Verteilt den verfügbaren Platz zwischen den Elementen
        alignItems: 'center',
    },
}));

//export const EditLinkDialog = ({ linkItem, handleEditDialogClose, editDialogOpen, linkTypeMap, setLinkArray, setLinkItem, linkArray, termArray }) => {

const PaperComponent = (props) => {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
};

export const EditLinkDialog = ({ handleEditDialogClose, editDialogOpen, linkTypeMap, linkItem }) => {

    const classes = useStyles();


    console.log("linkItem")
    console.log(linkItem)

    // Context
    const contextType = useContext(AuthContext);
    const dataContext = useContext(DataContext);
    const setLinkArray = dataContext.setLinkArray;
    const setTermItem = dataContext.setTermItem;
    let linkItemUdate = dataContext.linkItem;
    const setLinkItem = dataContext.setLinkItem;
    const linkArray = dataContext.linkArray;
    const termArray = dataContext.termArray;
    const setReloadContetnt = dataContext.setReloadContetnt;

    // Dialog Size
    // Du kannst sie auf "sm", "md", "lg", "xl" oder "false" setzen. Wenn du maxWidth="false" verwendest, wird die Breite nicht begrenzt.
    const [dialogSize, setdialogSize] = useState('sm');

    // Sicherstellen, dass `termArray` und `linkItem` definiert sind
    if (!termArray || !linkItem) {
        console.error("termArray oder linkItem ist nicht definiert");
        //return null; // Beenden Sie die Komponente, wenn die Daten fehlen
    }



    // Find Term by ID
    const toTerm = termArray.find(term => term._id === linkItem.toId) || {};
    const [currentToTerm, setCurrentToTerm] = useState(toTerm);

    const fromTerm = termArray.find(term => term._id === linkItem.fromId) || {};
    const [currentFromTerm, setCurrentFromTerm] = useState(fromTerm);

    useEffect(() => {
        const toTerm = termArray.find(term => term._id === linkItem.toId) || {};
        setCurrentToTerm(toTerm);

        const fromTerm = termArray.find(term => term._id === linkItem.fromId) || {};
        setCurrentFromTerm(fromTerm);
    }, [termArray, linkItem]);

    console.log("EditLinkDialog");
    console.log("-------------------------------------------------------");
    //console.log(linkItem)

    if (currentFromTerm && currentFromTerm.name) {
        console.log(currentFromTerm.name);
    }

    if (currentToTerm && currentToTerm.name) {
        console.log(currentToTerm.name);
    }


    const [values, setValues] = useState(
        {
            name: linkItem.name,
            description: linkItem.description,
            type: linkItem.type
        }
    );

    // If linkItem will change the values will be set again
    useEffect(() => {
        setValues({
            name: linkItem.name,
            description: linkItem.description,
            type: linkItem.type
        })
    }, [linkItem]);

    // Create an Description 
    const handleMakeDescription = () => {
        console.log("handleMakeDescription")
        const plainText = values.description.replace(/<[^>]*>/g, "");
        console.log(plainText)
        if (plainText === "") {
            setValues({
                name: values.name,
                description: currentFromTerm.name + " " + values.type + " " + currentToTerm.name,
                type: values.type
            })
        }
    };

    // Create an Description 
    const handleMakeDescriptionByChatGpt = () => {
        console.log("handleMakeDescription")
        const plainText = values.description.replace(/<[^>]*>/g, "");
        console.log(plainText)
        if (plainText === "") {
            GetRelatinDefinitionByChatGpt(currentFromTerm.name, currentToTerm.name, setValues, OPENAI_API_KEY)


        }
    };

    // Create an Description 
    const handleMakeTypeByChatGpt = () => {
        console.log("handleMakeDescription")
        const plainText = values.description.replace(/<[^>]*>/g, "");
        console.log(plainText)
        /* if (plainText === "") { */

        GetRelatinTypeByChatGpt(currentFromTerm.name, currentToTerm.name, setValues, OPENAI_API_KEY)

        //}
    };


    const handleClose = () => {
        ////console.log("--- Close")
        handleEditDialogClose();
    };

    const handleDelete = () => {
        // Delete Link
        DeleteLink(linkItem._id, setLinkArray, linkArray, contextType.token)
        handleEditDialogClose();
        //console.log("DeleteLink wit Id:" + linkItem._id)
    };


    const handleSave = () => {
        handleClose();
        // Save data 
        //console.log(values)
        if (values.name !== undefined) {
            linkItem.name = values.name;
        }
        if (values.description !== undefined) {
            linkItem.description = values.description;
        }
        if (values.type !== undefined) {
            linkItem.type = values.type;
            //linkItem.name = values.type;
        }

        if (currentToTerm !== undefined && currentFromTerm !== undefined) {
            linkItem.toId = currentToTerm._id;
            linkItem.fromId = currentFromTerm._id;
        }
        // Cummunication with Backend
        setReloadContetnt(Math.random)
        linkItemUdate = linkItem;
        UpdateLink(linkItem, contextType.token)
        setLinkItem(linkItem)// WARNING! if the Server connection went wrong the local term will change althought.
    };

    const handleChange = (event, newValue) => {
        let { value, name } = event.target;
        //console.log(values)
        setValues(values => {
            return {
                ...values,
                [name]: value
            };
        });
    };

    const handelSwitchDirction = () => {
        const tempTo = currentToTerm;
        const tempFrom = currentFromTerm;
        setCurrentToTerm(tempFrom);
        setCurrentFromTerm(tempTo);
    };

    const handleSize = () => {
        // Du kannst sie auf "sm", "md", "lg", "xl" oder "false" 
        if (dialogSize === "sm") {
            setdialogSize("lg")
        } else if (dialogSize === "lg") {
            setdialogSize("sm")
        }
    };


    return (
        <Fragment>
            <Dialog
                open={editDialogOpen}
                onClose={handleEditDialogClose}
                aria-labelledby="form-dialog-title"
                maxWidth={dialogSize}
                fullWidth="true"
                PaperComponent={PaperComponent}
            >
                <DialogTitle id="form-dialog-title">


                    <Box className={classes.flexContainer}>
                        <Typography className={classes.text} variant="h6"> Edit Link</Typography>
                        <TooltipStyle title={"Change dialog Size"} arrow>
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleSize}

                                edge="end"
                                size="small"
                            >
                                <AspectRatioIcon />
                            </IconButton>
                        </TooltipStyle>

                    </Box>

                </DialogTitle>



                <DialogContent>
                    <Box>
                        {currentFromTerm &&
                            <NameInput data={currentFromTerm} onChange={handleChange} classes={classes} label={"From"} />
                        }
                        <SelectLinkType
                            data={values}
                            onChange={handleChange}
                            classes={classes}
                            linkTypeMap={linkTypeMap}
                        />
                        <div>
                            <TooltipStyle title={"Switch Direction of Link"}>
                                <Fab
                                    className={classes.iconButton}
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    aria-label="more"
                                    size="small"
                                    onClick={handelSwitchDirction}
                                ><SwapVertIcon />
                                </Fab>
                            </TooltipStyle>
                        </div>
                        {currentFromTerm &&
                            <>

                                <NameInput data={currentToTerm} onChange={handleChange} classes={classes} label={"To"} />
                            </>
                        }
                        <Divider className={classes.divider} />

                        {(values.type === "generisch" || values.type === "generic") &&
                            <>
                                <TooltipStyle title={"Ask AI to generate the content for the generic type (Content have to be empty)"} arrow>
                                    <Button className={classes.button} variant="contained" color="primary" onClick={handleMakeTypeByChatGpt} startIcon={<BlurOnIcon />}>
                                        Generate Type
                                    </Button>
                                </TooltipStyle>
                                <TextField
                                    value={values.name}
                                    onChange={handleChange}
                                    className={classes.text}
                                    label={"Type Name"}
                                    name={"name"}
                                    variant="outlined"
                                />
                            </>
                        }

                        <TooltipStyle title={"Generate the content, by combine the informations (Content have to be empty)"} arrow>
                            <Button className={classes.button} variant="contained" color="primary" onClick={handleMakeDescription}>
                            Generate Content
                            </Button>
                        </TooltipStyle>

                        <TooltipStyle title={"Ask AI to generate the content (Content have to be empty)"} arrow>
                            <Button className={classes.button} variant="contained" color="primary" onClick={handleMakeDescriptionByChatGpt} startIcon={<BlurOnIcon />}>
                                Generate Content by AI
                            </Button>
                        </TooltipStyle>

                        <DescriptionInput data={values} onChange={handleChange} classes={classes} />
                        {/*  <TextField
                            value={values.description}
                            onChange={handleChange}
                            className={classes.text}
                            label={"Description"}
                            name={"description"}
                            variant="outlined"
                            multiline
                            maxRows={10} /> */}

                        <> ID: {linkItem._id}</>
                    </Box>
                    {linkItem.creator &&
                        <DialogContentText>
                            {"id: " + linkItem._id + " | Creator: " + linkItem.creator.email}
                        </DialogContentText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSave} variant="contained" color="primary" >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}